<textarea
    #cellInput
    class="editable-dataset-spreadsheet__cell-editor__input"
    name="cellInput"
    (keydown)="onKeyDown($event)"
    [value]="value ?? ''"
    (input)="onInput($event)"
></textarea>
